import React from "react";

const GetApp = () => {


  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/app-release.apk";
    link.download = "App-Release.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #e8f5ff, #f4fffc)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <header
        style={{
          display: "flex",
          alignItems: "center",
          padding: "20px 40px",
        }}
      >
        <img
          src="/assets/images/RNDSAN.jpeg"
          alt="Logo"
          style={{
            width: "60px",
            height: "60px",
            objectFit: "contain",
            marginRight: "15px",
          }}
        />

        <h2
          style={{
            color: "#e21313",
            fontSize: "28px",
            fontWeight: "700",
            margin: 0,
          }}
        >
          RNDSAN
        </h2>
      </header>

      {/* Download Card */}
      <div
        style={{
          margin: "auto",
          width: "90%",
          maxWidth: "650px",
          background: "#fff",
          padding: "50px",
          borderRadius: "24px",
          textAlign: "center",
          boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
        }}
      >
        <div
          style={{
            fontSize: "70px",
            marginBottom: "20px",
          }}
        >
          🏥
        </div>

        <h1
          style={{
            color: "#0f4c81",
            marginBottom: "15px",
            fontSize: "36px",
            fontWeight: "700",
          }}
        >
          Download Our Mobile App
        </h1>

        <p
          style={{
            color: "#555",
            lineHeight: "1.7",
            marginBottom: "30px",
            fontSize: "16px",
          }}
        >
        Manage patient registrations, book diagnostic tests, track appointments,
  maintain patient records, and streamline daily healthcare operations directly
  from your mobile device.
        </p>

        <button
          onClick={handleDownload}
          style={{
            background: "linear-gradient(135deg, #00b894, #00cec9)",
            color: "#fff",
            border: "none",
            padding: "18px 45px",
            borderRadius: "50px",
            fontSize: "20px",
            fontWeight: "600",
            cursor: "pointer",
            boxShadow: "0 12px 25px rgba(0,184,148,0.25)",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "translateY(-3px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0px)";
          }}
        >
          ⬇ Download APK
        </button>

        <p
          style={{
            marginTop: "20px",
            color: "#888",
            fontSize: "14px",
          }}
        >
          Android Version • Fast & Secure Download
        </p>
      </div>
    </div>
  );
};

export default GetApp;
